import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import { SelectOption } from '../../components/forms/select/select.component';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import { Helper } from '../../classes/helper';
import { User } from '../../classes/user';
import { UserService } from '../../services/user.service';
import { LoginService } from '../../services/login.service';
import { HasSubscriptions } from '../../components/has-subscriptions';
import { CustomValidators } from '../../classes/custom-validators';
import {CommunicationService} from '../../services/communication.service';
import {SCREEN_SIZE} from '../../classes/enums';
import { PreRenderService } from '../../services/pre-render.service';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: [
    './my-account.component.scss',
    './my-account.component.desktop.scss'
  ]
})
export class MyAccountComponent extends HasSubscriptions implements OnInit {
  user: User;
  toggleEditPassword = false;
  screenSize: number;

  showPasswordText = false;
  showConfirmPasswordText = false;

  accountForm: FormGroup;

  languageOptions: SelectOption[] = <any[]>[
    {
      text: 'English',
      value: 'English'
    },
    {
      text: 'French',
      value: 'french'
    }
  ];

  constructor(private userService: UserService,
              private loginService: LoginService,
              private route: Router,
              private prerenderService: PreRenderService,
              private communicationService: CommunicationService,
              private formBuilder: FormBuilder) {
    super();
    this.accountForm = this.formBuilder.group({
      email: [{value: '', disabled: true}],
      profile: this.formBuilder.group({
        name: [''],
        phoneNumber: '',
        language: this.languageOptions[0].value,
        buy: false,
        sell: false,
      }),
      password: this.formBuilder.group({
        password: ['', [Validators.min(6)]],
        confirmPassword: ['', [Validators.min(6)]]
      }, {validator: CustomValidators.passwordMatcher})
    });
  }

  ngOnInit() {
    this.addSub(this.userService.currentUser.subscribe(user => {
      // TODO: we probably should do something here if they;re not signed in
      this.prerenderService.setPreRenderFlag(200);
      this.user = user;
      this.accountForm.controls['email'].setValue(this.user.email);
      const profileFormGroup = this.accountForm.controls['profile'];
      profileFormGroup.get('phoneNumber').setValue(Helper.formatPhoneNumber(this.user.phoneNumber));
      profileFormGroup.get('name').setValue(this.user.name);
      profileFormGroup.get('language').setValue(this.user.language);
      profileFormGroup.get('buy').setValue(this.user.buy);
      profileFormGroup.get('sell').setValue(this.user.sell);
    }));

    this.addSub(this.communicationService.screenSize.subscribe((screenSize) => {
      this.screenSize = screenSize;
    }));
  }

  onSubmit() {
    const newUser = new User(this.user);

    const profileFormGroup = this.accountForm.controls['profile'];
    newUser.phoneNumber = profileFormGroup.get('phoneNumber').value;
    newUser.name = profileFormGroup.get('name').value;
    newUser.buy = profileFormGroup.get('buy').value;
    newUser.sell = profileFormGroup.get('sell').value;
    newUser.language = profileFormGroup.get('language').value;

    if (this.toggleEditPassword) {
      this.loginService.changePasswordWhileLoggedIn(this.accountForm.value.password.password.value);
    }

    // TODO: navigate to where they were
    this.userService.saveUser(newUser).then(s => {
      this.route.navigate(['/find-real-estate']);
    });
  }

  get passwordFormGroup() {
    return this.accountForm.get('password');
  }

  get password() {
    return this.passwordFormGroup.get('password');
  }

  get confirmPassword() {
    return this.passwordFormGroup.get('confirmPassword');
  }

  get profileFormGroup() {
    return this.accountForm.get('profile');
  }

  get name() {
    return this.profileFormGroup.get('name');
  }

  get email() {
    return this.accountForm.get('email');
  }

  get phoneNumber() {
    return this.profileFormGroup.get('phoneNumber');
  }

  SCREEN_SIZE = SCREEN_SIZE;
}

